export default [
  'date',
  'title',
  'subTheme',
  'status',
];
